"use strict";

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorListener = void 0;

var ErrorListener = /*#__PURE__*/_createClass(function ErrorListener() {
  var _this = this;

  _classCallCheck(this, ErrorListener);

  this.addOnErrorListener = function (func) {
    _this.errorListeners.push(func);
  };

  this.removeOnErrorListener = function (func) {
    _this.errorListeners = _this.errorListeners.filter(function (errorListenersFunc) {
      return func !== errorListenersFunc;
    });
  };

  this.fireError = function (error, type) {
    _this.errorListeners.forEach(function (errorListenersFunc) {
      errorListenersFunc(error, type);
    });
  };

  this.errorListeners = [];
});

exports.ErrorListener = ErrorListener;